module.exports = __webpack_public_path__ + "img/news_04.1820cfa3.jpg";